import { Button, Col, Input, message, Popconfirm, Row } from "antd";
import { DollarOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";

export default function CheckPayRequireFunction(props) {
  const [messageApi, contextHolder] = message.useMessage();

  const [sheetURL_p, setSheetURL_p] = useState('');
  const [sheetName_p, setSheetName_p] = useState('');

  const [tabsNum, setTabsNum] = useState('10');

  const check = async (profile) => {
    if(!sheetURL_p) {
      alert("Data GG Sheet chưa nhập !!!")
      return;
    }
    
    messageApi.info(`>>> Check pay Profiles...`);
    let body = {
      sheet: {
        sheetId: sheetURL_p.split('/d/')[1].split('/edit')[0], 
        sheetName: sheetName_p,
      },
      tabsNum
    };
    axios
      .post(`${API_HOST}/api/check-pay-profiles`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ check pay Profiles ~ error:", e);
        messageApi.error(e.response.data);
      });
  };
  useEffect(() => {
    let sheetNameP = localStorage.getItem('check-pay-sheetName')
    if(sheetNameP) {
      setSheetName_p(sheetNameP)
    }
    let sheetURLP = localStorage.getItem('check-pay-sheetURL')
    if(sheetURLP) {
      setSheetURL_p(sheetURLP)
    }

    let tabsNum = localStorage.getItem('check-pay-tabs')
    if(tabsNum) {
      setTabsNum(tabsNum)
    }
  }, [])

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ width: '500px' }}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Check Pay XM Profiles"
        description={
          <div style={{ width: '500px' }}>
            <b>Profiles GG sheet: </b>
            <Row>
              <Col span={4}>
                <label>SL Chrome: </label>
              </Col>
              <Col span={20}>
                <Input
                  value={tabsNum}
                  type="number"
                  style={{ width: 60 }}
                  placeholder="Số Lượng Chrome..."
                  onChange={(e) => {
                    setTabsNum(e.target.value);
                    localStorage.setItem('check-pay-tabs', e.target.value);
                  }}
                />
              </Col>
              <Col span={4}>
                <label>URL: </label>
              </Col>
              <Col span={18}>
               <Input
                  value={sheetURL_p}
                  style={{ width: 400 }}
                  placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
                  onChange={(e) => {
                    setSheetURL_p(e.target.value);
                    localStorage.setItem('check-pay-sheetURL', e.target.value);
                  }}
                />
              </Col>
              <Col span={4}>
                <label>Trang: </label>
              </Col>
              <Col span={18}>
                 <Input
                    value={sheetName_p}
                    style={{ width: 200 }}
                    placeholder="Trang Check pay..."
                    onChange={(e) => {
                      setSheetName_p(e.target.value);
                      localStorage.setItem('check-pay-sheetName', e.target.value);
                    }}
                  />
              </Col>
            </Row>
          </div>
        }
        onConfirm={() => check(props.profile)}
      >
        <Button danger ><DollarOutlined />Check Pay</Button>
      </Popconfirm>
    </>
  );
}